import {

    useEffect,
    useState

} from 'react';

import {

    deleteUser,
    getUsers,
    updateUser

} from '../../../api/adminApi';

import './UserManage.css';

const UserManage = () => {





    // 회원 리스트
    const [users, setUsers] =

        useState<any[]>([]);





    // 검색
    const [keyword, setKeyword] =

        useState('');





    // 페이지
    const [page, setPage] =

        useState(1);





    // 전체 개수
    const [total, setTotal] =

        useState(0);





    // 수정 팝업
    const [editOpen, setEditOpen] =

        useState(false);





    // 수정 회원
    const [selectedUser, setSelectedUser] =

        useState<any>(null);





    // 수정값
    const [editNickname, setEditNickname] =

        useState('');





    const [editRole, setEditRole] =

        useState('USER');





    // 최초 실행
    useEffect(() => {

        loadUsers();

    }, [page]);





    // 회원 조회
    const loadUsers = async () => {

        try {

            const response =

                await getUsers(

                    page,

                    keyword
                );





            setUsers(

                response.data.users
            );





            setTotal(

                response.data.total
            );

        } catch (e) {

            console.error(e);
        }
    };





    // 검색
    const handleSearch = () => {

        setPage(1);

        loadUsers();
    };





    // 삭제
    const handleDelete = async (

        userId: number
    ) => {

        const ok = window.confirm(

            '회원 삭제하시겠습니까?'
        );





        if(!ok) return;





        try {

            await deleteUser(userId);





            alert('삭제 완료');





            loadUsers();

        } catch (e) {

            console.error(e);

            alert('삭제 실패');
        }
    };





    // 수정 팝업 열기
    const openEdit = (

        user: any
    ) => {

        setSelectedUser(user);





        setEditNickname(

            user.nickname
        );





        setEditRole(

            user.role
        );





        setEditOpen(true);
    };





    // 수정 저장
    const handleUpdate = async () => {

        try {

            await updateUser(

                selectedUser.id,

                editNickname,

                editRole
            );





            alert('수정 완료');





            setEditOpen(false);





            loadUsers();

        } catch (e) {

            console.error(e);

            alert('수정 실패');
        }
    };





    return (

        <div className="user-manage">

            {/* 상단 */}
            <div className="user-top-bar">

                <div className="user-search-wrap">

                    <input

                        type="text"

                        placeholder="닉네임 또는 이메일 검색"

                        value={keyword}

                        onChange={(e) =>

                            setKeyword(
                                e.target.value
                            )
                        }

                        className="user-search-input"
                    />





                    <button

                        className="user-search-button"

                        onClick={handleSearch}
                    >

                        검색

                    </button>

                </div>





                <div className="user-count">

                    전체 회원 {total}명

                </div>

            </div>





            {/* 리스트 */}
            <div className="user-list">

                {

                    users.map((user) => (

                        <div

                            className="user-card"

                            key={user.id}
                        >

                            <div className="user-info">

                                <div className="user-nickname">

                                    {user.nickname}

                                </div>





                                <div className="user-email">

                                    {user.email}

                                </div>





                                <div className="user-role">

                                    {user.role}

                                </div>

                            </div>





                            <div className="user-actions">

                                <button

                                    className="edit-button"

                                    onClick={() =>

                                        openEdit(user)
                                    }
                                >

                                    수정

                                </button>





                                <button

                                    className="delete-button"

                                    onClick={() =>

                                        handleDelete(
                                            user.id
                                        )
                                    }
                                >

                                    삭제

                                </button>

                            </div>

                        </div>
                    ))
                }

            </div>





            {/* 수정 팝업 */}
            {

                editOpen && (

                    <div className="user-modal-overlay">

                        <div className="user-modal">

                            <div className="modal-title">

                                회원 수정

                            </div>





                            <input

                                type="text"

                                value={editNickname}

                                onChange={(e) =>

                                    setEditNickname(
                                        e.target.value
                                    )
                                }

                                className="modal-input"
                            />





                            <select

                                value={editRole}

                                onChange={(e) =>

                                    setEditRole(
                                        e.target.value
                                    )
                                }

                                className="modal-select"
                            >

                                <option value="USER">

                                    USER

                                </option>





                                <option value="ADMIN">

                                    ADMIN

                                </option>

                            </select>





                            <div className="modal-buttons">

                                <button

                                    className="save-button"

                                    onClick={handleUpdate}
                                >

                                    저장

                                </button>





                                <button

                                    className="cancel-button"

                                    onClick={() =>

                                        setEditOpen(false)
                                    }
                                >

                                    취소

                                </button>

                            </div>

                        </div>

                    </div>
                )
            }

        </div>
    );
};

export default UserManage;